/**
 * Use Case: Delete Voucher
 * Business logic for deleting an existing voucher.
 */

import type { IRewardCatalogRepository } from "../repository/IRewardCatalogRepository";
import { rewardCatalogContainer, TYPES } from "../../di/RewardCatalogModule";

/**
 * Delete a voucher by ID
 */
export const DeleteVoucherUseCase = async (voucherId: string): Promise<void> => {
  const repository = rewardCatalogContainer.get<IRewardCatalogRepository>(
    TYPES.IRewardCatalogRepository
  );
  return repository.deleteVoucher(voucherId);
};

